import { asyncAction, WebPlayerCredentials } from '@play-co/replicant';
import createActions from '../config/actions/createActions';
import { restoreFromState } from './guest.modifiers';
import { grantMatch2Rewards } from '../match2/match2.modifiers';
import { guestLineLoginReward } from './guest.ruleset';

export const guestActions = createActions({
  asyncRestoreFromGuest: asyncAction(
    async (
      state,
      { credentials }: { credentials: WebPlayerCredentials },
      api,
    ) => {
      if (
        api.loginLinks.createWebPlayerToken({ userId: credentials.id }) !==
        credentials.token
      ) {
        const error = 'Could not restore from guest state: invalid token';
        api.reportError(new Error(error));
        return { success: false, error };
      }

      const query = await api.fetchStates([credentials.id]);
      const guestState = query[credentials.id];

      if (!guestState) {
        const error =
          'Could not restore from guest state: guest state not found';
        api.reportError(new Error(error));
        return { success: false, error };
      }

      restoreFromState(
        state,
        guestState.state,
        guestState.metainfo.abTestAssignments ?? {},
        api,
      );

      // Grant rewwards for the newly converted player
      grantMatch2Rewards(
        state,
        [guestLineLoginReward],
        { feature: 'guest_to_line' },
        api,
      );

      return { success: true };
    },
  ),
});
